import { configureStore } from "@reduxjs/toolkit";
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from "react-redux";
import { authorizeSlice } from "./authorize";

// State

export interface StoreState {}

export const store = configureStore({
  reducer: {
    authorize: authorizeSlice.reducer,
  },
  preloadedState: {},
  devTools: true,
});

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Hooks
export const useDispatch = useAppDispatch.withTypes<AppDispatch>();
export const useSelector = useAppSelector.withTypes<RootState>();
